import { Loader } from '@googlemaps/js-api-loader';
import 'slick-carousel/slick/slick.min.js';

function init() {
  jQuery('.acf-map').each(function(){
    // create map
    newMap( jQuery(this) );
  });

  jQuery(document).ready(function () {
    jQuery('.vertical-slider').slick({
      dots: false,
      infinite: false,
      speed: 1000,
      autoplay: false,
      fade: true,
      prevArrow: '<button type="button" class="slick-prev"><</button>',
      nextArrow: '<button type="button" class="slick-next">></button>',
    });
  });
}

function newMap( $el ) {

  // create map via promise
  const loader = new Loader({
    apiKey: 'AIzaSyDj8-sp2yFCZYgYgZX4RBMOdHOlE6UOGOI',
    version: 'weekly',
    libraries: ['places'],
  });

  loader
  .load()
  .then(() => {

    var $markers = $el.find('.marker');
    var mapOptions = {
      zoom		: 6,
      center: new google.maps.LatLng(52.573846, -3.024121),
      mapTypeId	: google.maps.MapTypeId.ROADMAP,
      scrollwheel : false,
      styles: [{
          'featureType': 'water',
          'elementType': 'geometry',
          'stylers': [{
              'color': '#e9e9e9',
            },
            {
              'lightness': 17,
            },
          ],
        },
        {
          'featureType': 'landscape',
          'elementType': 'geometry',
          'stylers': [{
              'color': '#f5f5f5',
            },
            {
              'lightness': 20,
            },
          ],
        },
        {
          'featureType': 'road.highway',
          'elementType': 'geometry.fill',
          'stylers': [{
              'color': '#ffffff',
            },
            {
              'lightness': 17,
            },
          ],
        },
        {
          'featureType': 'road.highway',
          'elementType': 'geometry.stroke',
          'stylers': [{
              'color': '#ffffff',
            },
            {
              'lightness': 29,
            },
            {
              'weight': 0.2,
            },
          ],
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'geometry',
          'stylers': [{
              'color': '#ffffff',
            },
            {
              'lightness': 18,
            },
          ],
        },
        {
          'featureType': 'road.local',
          'elementType': 'geometry',
          'stylers': [{
              'color': '#ffffff',
            },
            {
              'lightness': 16,
            },
          ],
        },
        {
          'featureType': 'poi',
          'elementType': 'geometry',
          'stylers': [{
              'color': '#f5f5f5',
            },
            {
              'lightness': 21,
            },
          ],
        },
        {
          'featureType': 'poi.park',
          'elementType': 'geometry',
          'stylers': [{
              'color': '#dedede',
            },
            {
              'lightness': 21,
            },
          ],
        },
        {
          'elementType': 'labels.text.stroke',
          'stylers': [{
              'visibility': 'on',
            },
            {
              'color': '#ffffff',
            },
            {
              'lightness': 16,
            },
          ],
        },
        {
          'elementType': 'labels.text.fill',
          'stylers': [{
              'saturation': 36,
            },
            {
              'color': '#333333',
            },
            {
              'lightness': 40,
            },
          ],
        },
        {
          'elementType': 'labels.icon',
          'stylers': [{
            'visibility': 'off',
          }],
        },
        {
          'featureType': 'transit',
          'elementType': 'geometry',
          'stylers': [{
              'color': '#f2f2f2',
            },
            {
              'lightness': 19,
            },
          ],
        },
        {
          'featureType': 'administrative',
          'elementType': 'geometry.fill',
          'stylers': [{
              'color': '#fefefe',
            },
            {
              'lightness': 20,
            },
          ],
        },
        {
          'featureType': 'administrative',
          'elementType': 'geometry.stroke',
          'stylers': [{
              'color': '#fefefe',
            },
            {
              'lightness': 17,
            },
            {
              'weight': 1.2,
            },
          ],
        },
      ],
  };

    var map = new google.maps.Map($el[0], mapOptions);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function(){
      addMarker( $(this), map );
    });

    // center map
    centerMap( map );

    // return
    return map;
  })
  .catch(e => {
    console.log('Unable to load Google Maps:');
    console.log(e);
  });
}

function addMarker( $marker, map ) {

  var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
  var iconurl = $( '.acf-map' ).data('icon');

  // custom icon
    var icons = {
        postcode: {
            icon: iconurl + '/marker.png'
        },
        morrisons: {
            icon: iconurl + '/marker-morrisons.png'
        },
        tesco: {
            icon: iconurl + '/marker-tesco.png'
        },
        asda: {
            icon: iconurl + '/marker-asda.png'
        }
    };

    var type = $marker.data('type');
    var icon = icons[type]['icon'];

    console.log(type + ': ' + icon)

  // create marker
  var marker = new google.maps.Marker({
    position: latlng,
    map: map,
    icon: icon,
  });

  // add to array
  map.markers.push( marker );

  // if marker contains HTML, add it to an infoWindow
  if( $marker.html() )
  {
    // create info window
    var infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });

    // show info window when marker is clicked
    google.maps.event.addListener(marker, 'click', function() {
      infowindow.open( map, marker );
    });
  }
}

function centerMap( map ) {
  if( map.markers.length === 0 ) {
      return;
  }

  // vars
  var bounds = new google.maps.LatLngBounds();

  // loop through all markers and create bounds
  $.each( map.markers, function( i, marker ){
    var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
    bounds.extend( latlng );
  });

  // only 1 marker?
  if( map.markers.length === 1 ) {
    // set center of map
    map.setCenter( bounds.getCenter() );
  } else {
    // fit to bounds
    map.fitBounds( bounds );
  }
}

export default { init, addMarker, centerMap }



// WEBPACK FOOTER //
// ./scripts/routes/where-to-buy.js